<div class="screen-element settingsvalue">
  <div class="title" [ngClass]="{'dark':hasParameter('darkTitle'),'light':lightTitle,'darkerTitle':hasParameter('darkerTitle')}">{{title|uppercase}}@if (menuIcon) {
    <span class="menu-icon inline-icon {{menuIcon}}">&nbsp;</span>
  }</div>
  <div class="subtitle" [ngClass]="{'dark':hasParameter('darkSubtitle'),'light':hasParameter('lightSubtitle')}">{{subTitle|uppercase}}</div>
  @if (hasParameter('smallValue')) {
    <div class="settingsvalue-center" >
      @if (!valueIsIcon()) {
        <div class="value background smallValue" [ngClass]="{'blink':isBlinking}" [ngStyle]="{'left':valueLeft}">{{getValue()}} {{getUnit()}}@if (currentChar) {
          <span class="currentChar">{{currentChar}}</span>
        }</div>
      }
      @if (valueIsIcon()) {
        <div class="value background smallValue icon {{getValue()}}" [ngClass]="{'blink':isBlinking}" [ngStyle]="{'left':valueLeft}">@if (currentChar) {
          <span class="currentChar">{{currentChar}}</span>
        }</div>
      }
    </div>
  }
  @if (!hasParameter('smallValue') && !valueIsIcon()) {
    <div class="settingsvalue-center" >
      <div class="value background" [ngClass]="{'blink':isBlinking}" [ngStyle]="{'left':valueLeft}">{{getValue()}}@if (currentChar) {
        <span class="currentChar">{{currentChar}}</span>
      }</div>
      <div class="unit">{{getUnit()}}</div>
    </div>
  }
  @if (!hasParameter('smallValue') && valueIsIcon()) {
    <div class="settingsvalue-center" >
      <div class="value background inline-icon {{getValue()}}" [ngClass]="{'blink':isBlinking}" [ngStyle]="{'left':valueLeft}">&nbsp;</div>
    </div>
  }

  @if (showMarker) {
    <div class="marker"></div>
  }
  @if (showTexts) {
    <div [ngClass]="{'bright':brightText}">
      <div class="text text-1" [ngClass]="{'bright':brightText1}" >{{currentNode.getText(0)}}</div>
      <div class="text text-2" [ngClass]="{'bright':brightText2}">{{currentNode.getText(1)}}</div>
      <div class="text text-3" [ngClass]="{'bright':brightText3}">{{currentNode.getText(2)}}</div>
    </div>
  }
  @if (showTextInput) {
    <div class="alphabet">
      <app-textinput [stringtype]="type" [text]="getValue()" (currentCharChanged)="currentCharChanged($event)" (onTextChanged)="textChanged($event)" (onSave)="saveText($event)"></app-textinput>
    </div>
  }
</div>